export default __webpack_public_path__ + "static/welding-f0c8c506fbf45f98c1405bfdc552e5b9.jpeg";